export class AppliedAmountEditorLineItemInfo {
    line: number;
    amount: number;
    appliedAmount: number;
    remainingUnapplied: number;
    itemId: number;
}
